import React, { useEffect, useState } from "react";
import Ratingscale from "./components/Ratingscale";
import Slider from "./components/Slider";
import "./css/dpi-admin.css";
import axios from "axios";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useNavigate } from "react-router-dom";
import API_BASE_URL from "./config";
import Fileuploader from "./components/Fileuploader";
import Surveymain from "./components/Surveymain";

export default function Survey() {
  const [survey, setSurvey] = useState([]);
  const [savedquestions, setSavedQuestions] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [savesuccessful, setSaveSuccessful] = useState(false);
  const [surveyuuid, setSurveyUuid] = useState(queryParams.get("su"));
  const [surveyvalid, setSurveyValid] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  let navPage = useNavigate();

  /*useEffect(() => {
    const getQuestions = async () => {
      const resQues = await fetch(
        `${API_BASE_URL}GetAllQuestionsBySurveyUUId.php/${survey_uuid}`
      );
      const resquesjson = await resQues.json();
      setSavedQuestions(await resquesjson);
    };
    getQuestions();
  }, [blnupdatelist]);*/

  useEffect(() => {
    const user_name = sessionStorage.getItem("user_credential")
      ? JSON.parse(sessionStorage.getItem("user_credential")).user_name
      : "";
    const formData = new FormData();
    formData.append("survey_uuid", surveyuuid);
    formData.append("user_name", user_name);

    const templsaver = axios
      .post(`${API_BASE_URL}GetAllQuestionsBySurveyUUId.php`, formData, {
        hearders: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        const data = Object.values(response);
        //console.log(response);
        if (response.data !== "invalid" && response.data !== "") {
          setIsLoading(false);
          setSavedQuestions(data[0]);
          //CreateSection(data[0]);
        } else {
          setSurveyValid(false);
          setSavedQuestions([]);
        }
      })
      .catch((error) => {
        //console.log(error);
        setSurveyValid(false);
        return false;
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const handleControlChange = (id, value, ctrlName, checked = 0) => {
    const prevSavedquestions = savedquestions;
    let checkNewvalue = value;
    const objectExists = prevSavedquestions.questions.some(
      (obj) => parseInt(obj.surv_ques_id) === parseInt(id)
    );

    if (objectExists) {
      if (ctrlName === "Check Box") {
        const question = savedquestions.questions.find(
          (q) => parseInt(q.surv_ques_id) === parseInt(id)
        );
        if (checked) {
          const oldVal = question.input_val ? question.input_val : "";
          checkNewvalue = oldVal === "" ? value : oldVal + "," + value;
        } else {
          const oldVal = question.input_val
            .split(",")
            .map((value) => value.trim());

          const filteredValues = oldVal.filter((val) => val !== value.trim());
          checkNewvalue = filteredValues.join(",");
        }
      }

      setSavedQuestions((prevData) => ({
        ...prevData,
        questions: prevData.questions.map((question) =>
          parseInt(question.surv_ques_id) === parseInt(id)
            ? { ...question, input_val: checkNewvalue }
            : question
        ),
      }));
    }
  };

  const fetchItemById = (id) => {
    const foundItem = savedquestions.questions.find(
      (item) => parseInt(item.surv_ques_id) === parseInt(id)
    );

    if (foundItem) {
      // If an item with the matching id is found, you can access its values
      return foundItem.input_val; // or any other property you want
    } else {
      return "";
    }
  };

  const handlesubmit = () => {
    //console.log(survey);//savedquestions.surveyinfo[0].id);
    //if (IsValidateSurvey()) {
    saveSurvey();
    //}

    //console.log(JSON.stringify(savedquestions));
  };
  /*const IsValidateSurvey = () => {
    let blnValid = true;
    savedquestions.questions.forEach((question) => {
      if (
        question.is_req === 1 &&
        (!question.input_val || question.input_val === "")
      ) {
        setSavedQuestions((prevData) => ({
          ...prevData,
          questions: prevData.questions.map((ques) =>
            parseInt(ques.surv_ques_id) === parseInt(question.surv_ques_id)
              ? { ...question, error_msg: ques.surv_ques_label + " is missing" }
              : question
          ),
        }));
        blnValid = false;
      }
    });
    return blnValid;
  };*/
  const saveSurvey = () => {
    /*const surveyArray = [
      {
        surv_uuid: surveyuuid,
        user_name: sessionStorage.getItem("user_credential")
          ? JSON.parse(sessionStorage.getItem("user_credential")).user_name
          : "",
      },
      { user_response: survey },
    ];*/

    const formfldData = new FormData();
    //formfldData.append("surveyuserresponse", JSON.stringify(surveyArray));
    formfldData.append("surveyuserresponse", JSON.stringify(savedquestions));

    const templsaver = axios
      .post(`${API_BASE_URL}InsertUserSurveyResponse.php`, formfldData, {
        hearders: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        setSaveSuccessful(true);
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };

  if (isLoading) {
    return (
      <div className="loader">
        <div className="spinner"></div>
        <p>Loading Page, please wait...</p>
      </div>
    );
  }

  return (
    <>
      {(savesuccessful && (
        <div className="col-xl-8 mx-auto" style={{ marginTop: "15%" }}>
          <h4>
            <span class="btn btn-success btn-circle">
              <i class="fas fa-check"></i>
            </span>
            &nbsp; Your survey response successfully saved! Thanks for your
            valuable time.
            <hr></hr>
          </h4>
        </div>
      )) ||
        (!surveyvalid && (
          <div className="col-xl-8 mx-auto" style={{ marginTop: "15%" }}>
            <h4>
              <span class="btn btn-warning btn-circle mb-1">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              &nbsp;Please contact administrator. You may not see survey due to
              one of the following reasons:{" "}
            </h4>
            <ul class="list-group">
              <li class="list-group-item">
                <i></i>You already submitted your response for survey.
              </li>
              <li class="list-group-item">Survey expired.</li>
              <li class="list-group-item">Survey not assigned to you.</li>
            </ul>
          </div>
        )) || (
          <>
            {!isLoading && (
              <Surveymain
                surveyData={savedquestions}
                handleControlChange={handleControlChange}
                onSubmit={handlesubmit}
              />
            )}
          </>
        )}
      <hr></hr>
    </>
  );
}
